<!--首页模块五-->
<template>
  <div style="font-family: Alibaba">
    <!--新闻资讯标题-->
    <div class='title'>
      <div>
        <h1>
          <i class="el-icon-caret-right"></i>{{ cnNameFiev }}
        </h1>
        <p>{{ enNameFive }}</p>
      </div>
    </div>
    <!--新闻资讯-->
    <el-tabs  class="box-width" v-model="activeName" @tab-click="handleClick">
      <!--公司新闻-->
      <el-tab-pane label="公司新闻" name="first">
        <el-row :gutter="20" class="carbon">
          <!--图片-->
          <el-col :md="12" :sm="12" :xs="24">
            <div class="news_img">
              <el-image
                style="width: 100%;height: 360px"
                alt="Image Description"
                :src="homeImgUrl"
                :fit="fit"></el-image>
            </div>
          </el-col>
          <!--列表-->
          <el-col :md="12" :sm="12" :xs="24">
            <ul class="tab_ul">
              <li v-for="item in newListAll" :key="item.id">
                <a href="#" @click='handleNewDetail(item.id)' @mouseover="updateHomeImgUrl(item.fullPathUrl)">
                  {{ item.briefIntroduction }}
                </a>
              </li>
            </ul>
            <el-pagination style="text-align: right"
                           small
                           layout="prev, pager, next"
                           next-text="下一页"
                           prev-text="上一页"
                           v-show="total>0"
                           @prev-click='upPage'
                           @next-click='upPage'
                           @current-change='upPage'
                           :total='total'
                           :page.sync='queryParams.pageNum'
                           :page-size="queryParams.pageSize"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!--行业资讯-->
      <el-tab-pane label="行业资讯" name="second">
        <el-row :gutter="20" class="carbon">
          <!--图片-->
          <el-col :md="12" :sm="12" :xs="24">
            <div class="tab_img">
              <div class="news_img">
                <el-image
                  style="width: 100%;height: 360px"
                  alt="Image Description"
                  :src="homeImgUrl2"
                  :fit="fit"></el-image>
              </div>
            </div>
          </el-col>
          <!--列表-->
          <el-col :md="12" :sm="12" :xs="24">
            <ul class="tab_ul">
              <li v-for="item in newListAll2" :key="item.id">
                <a href="#" @click='handleInformationDetail(item.id)' @mouseover="updateHomeImgUrl2(item.fullPathUrl)">
                  {{ item.briefIntroduction }}
                </a>
              </li>
            </ul>
            <el-pagination style="text-align: right"
                           small
                           layout="prev, pager, next"
                           next-text="下一页"
                           prev-text="上一页"
                           v-show="total2>0"
                           @prev-click='upPage2'
                           @next-click='upPage2'
                           @current-change='upPage2'
                           :total='total2'
                           :page.sync='queryParams2.pageNum'
                           :page-size="queryParams2.pageSize"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!--视频新闻-->
      <el-tab-pane label="视频新闻" name="fourth">
        <el-row :gutter="20" class="carbon" style="min-width:1000px">
          <!--视频-->
          <el-col :md="12" :sm="12" :xs="24">
            <div>
              <video
                controls
                :src="homeImgUrl3 != null ? homeImgUrl3 : ''"
                style="width: 100%; height: auto;margin-top: 20px"></video>
            </div>
          </el-col>
          <!--列表-->
          <el-col :md="12" :sm="12" :xs="24">
            <ul class="tab_ul">
              <li v-for="item in videoListAll" :key="item.id">
                <a href="#" @click='handleVideoDetail(item.id)' @mouseover="updateHomeImgUrl3(item.fullPathUrl)">
                  {{ item.briefIntroduction }}
                </a>
              </li>
            </ul>
            <el-pagination style="text-align: right"
                           small
                           layout="prev, pager, next"
                           next-text="下一页"
                           prev-text="上一页"
                           v-show="total3>0"
                           @prev-click='upPage3'
                           @next-click='upPage3'
                           @current-change='upPage3'
                           :total='total3'
                           :page.sync='queryParams3.pageNum'
                           :page-size="queryParams3.pageSize"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { findEnNameOne, findHomeFive, getInformationlList, getVideoList, listNews } from '@/api/zh'

export default {
  created () {
  },
  data () {
    return {
      activeName: 'first',
      enNameFive: '',
      cnNameFiev: '',
      newListAll: [],
      homeImgUrl: '',
      total: 0,
      cnEnNameId: null,
      queryParams: {
        cnEnNameId: null,
        pageNum: 1,
        pageSize: 10
      },

      newListAll2: [],
      homeImgUrl2: '',
      total2: 0,
      queryParams2: {
        cnEnNameId: null,
        pageNum: 1,
        pageSize: 10
      },

      videoListAll: [],
      homeImgUrl3: '',
      total3: 0,
      queryParams3: {
        cnEnNameId: null,
        pageNum: 1,
        pageSize: 10
      },

      fit: 'cover',
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png')
    }
  },
  mounted () {
    this.selectFive()
    this.selectNewsAll()
    this.selectInformationAll()
    this.selectVideoAll()
  },
  methods: {
    /** 查询英文名称 */
    selectEnName (cnEnNameId) {
      let that = this
      findEnNameOne(cnEnNameId).then(res => {
        let data = res.data
        that.enNameFive = data.enName
        that.cnNameFiev = data.cnName
      })
    },
    async selectFive () {
      let that = this
      await findHomeFive().then(res => {
        if (res.data.cnEnNameId !== null) {
          that.selectEnName(res.data.cnEnNameId)
        }
      })
    },
    handleClick (val) {
      console.log(val.label)
      if (val.label === '视频新闻') {
        this.playVideo()
      }
    },
    playVideo () {
      this.$refs.videoPlayer.play()
    },
    upPage (raw) {
      this.queryParams.pageNum = raw
      this.selectNewsAll()
    },
    /** 查询新闻列表 */
    async selectNewsAll () {
      let that = this
      await listNews(this.queryParams).then(res => {
        that.total = res.total
        that.newListAll = res.rows
        // 检查是否有数据并且第一个item的fullPathUrl不为空
        if (that.newListAll.length > 0 && that.newListAll[0].fullPathUrl) {
          that.homeImgUrl = that.newListAll[0].fullPathUrl
        }
      })
    },
    /** 新闻详情 */
    handleNewDetail: function (id) {
      const routeData = this.$router.resolve({
        path: '/newsDetail',
        query: {
          newsId: id
        }
      })
      window.open(routeData.href, '_blank')
    },
    /** 更新homeImgUrl */
    updateHomeImgUrl (fullPathUrl) {
      if (fullPathUrl != null) {
        this.homeImgUrl = fullPathUrl
      }
    },
    /** 查询资讯列表 */
    async selectInformationAll () {
      let that = this
      await getInformationlList(this.queryParams2).then(res => {
        that.total2 = res.total
        that.newListAll2 = res.rows
        // 检查是否有数据并且第一个item的fullPathUrl不为空
        if (that.newListAll2.length > 0 && that.newListAll2[0].fullPathUrl) {
          that.homeImgUrl2 = that.newListAll2[0].fullPathUrl
        }
      })
    },
    /** 资讯详情 */
    handleInformationDetail: function (id) {
      const routeData = this.$router.resolve({
        path: '/informationDetail',
        query: {
          informationId: id
        }
      })
      window.open(routeData.href, '_blank')
    },
    /** 更新homeImgUrl */
    updateHomeImgUrl2 (fullPathUrl) {
      if (fullPathUrl != null) {
        this.homeImgUrl2 = fullPathUrl
      }
    },
    upPage2 (raw) {
      this.queryParams2.pageNum = raw
      this.selectInformationAll()
    },
    upPage3 (raw) {
      this.queryParams3.pageNum = raw
      this.selectVideoAll()
    },
    async selectVideoAll () {
      let that = this
      await getVideoList(this.queryParams3).then(res => {
        that.total3 = res.total
        that.videoListAll = res.rows
        // 检查是否有数据并且第一个item的fullPathUrl不为空
        if (that.videoListAll.length > 0 && that.videoListAll[0].fullPathUrl) {
          that.homeImgUrl3 = that.videoListAll[0].fullPathUrl
        }
      })
    },
    /** 视频详情 */
    handleVideoDetail: function (id) {
      const routeData = this.$router.resolve({
        path: '/videoDetails',
        query: {
          videoId: id
        }
      })
      window.open(routeData.href, '_blank')
    },
    /** 更新homeImgUrl */
    updateHomeImgUrl3 (fullPathUrl) {
      if (fullPathUrl != null) {
        this.homeImgUrl3 = fullPathUrl
      }
    }
  }
}
</script>
<style scoped>
</style>
